import api, { operationId } from "@/api/posApi"
const kinds = { receivable_waive: "dunning_fee_waived", receivable_bank: "bank_receivable_payment", receivable_bank_manual: "bank_receivable_payment", receivable_bank_correction: "bank_receivable_correction" }
export const invoiceRef = row => ({ source: row.source, invoiceId: row.invoiceId, ...(row.agreementId ? { agreementId: row.agreementId } : {}) })
export function commandKey(context, studioId) {
  if (!context.tenantId || !context.user || !context.user._id || !studioId) return ""
  return "pos-receivables-command-v1:" + context.tenantId + ":" + context.user._id + ":" + studioId
}
export function readCommand(key) {
  if (!key) return null
  const saved = JSON.parse(localStorage.getItem(key) || "null")
  if (saved && (!saved.body || !kinds[saved.body.kind] || !/^[a-f\d]{24}$/i.test(saved.studioId) || !/^[a-z\d-]{16,80}$/i.test(saved.body.requestId) || saved.body.mode !== "live" || saved.body.cashModel !== "studio-v2" || !Number.isSafeInteger(saved.body.sequence))) throw Error("Der gespeicherte Forderungsauftrag muss geprüft werden. Bitte die Gerätedaten nicht löschen.")
  return saved
}
export async function prepareCommand(key, studioId, fields) {
  if (!key || !kinds[fields.kind]) throw Error("Bitte den Arbeitsbereich neu laden.")
  if (localStorage.getItem(key)) throw Error("Bitte zuerst den offenen Buchungsstatus prüfen.")
  const current = await api.cashManagementState(studioId + ":bar")
  if (!current.register || current.register.mode !== "live" || current.register.pending) throw Error("Bitte zuerst den Kassenstatus prüfen.")
  const saved = { studioId, body: { ...fields, mode: "live", cashModel: "studio-v2", requestId: operationId(), sequence: current.register.sequence } }
  localStorage.setItem(key, JSON.stringify(saved))
  return saved
}
export async function retryCommand(key, saved) {
  try {
    const result = await api.cashManagementCommand(saved.studioId + ":bar", saved.body)
    if (!result || !result.entry || result.entry.kind !== kinds[saved.body.kind] || String(result.entry.studioId) !== saved.studioId) throw Error("Der Buchungsstatus ist noch nicht eindeutig bestätigt.")
    localStorage.removeItem(key)
    return result
  } catch (error) {
    if (error.response && error.response.data && error.response.data.cashCommandRejected === true) localStorage.removeItem(key)
    throw error
  }
}
